<script>
    import {Link} from "svelte-navigator";

    export let id;
    export let title;
    export let content;
    export let date;

    $: dateStr = date.toDate().toLocaleDateString("sk-SK");

    $:previewText = content
        .find(itm => itm.type === 'text')
        .value.substring(0, 345).concat('...');

</script>

<!--------------------------------------------------------------------------------------------------------------------->

<article>
    <div class="title">
        <Link to={`${id}`}><h2>{title}</h2></Link>
        <time>{dateStr}</time>
    </div>

    <div class="preview">
        <p>{previewText}</p>
    </div>
</article>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    article {
        max-height: 300px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 4rem;
    }
    .title {
        flex: 1;
    }
    .preview {
        flex: 2;
    }

    h2:hover {
        text-decoration: underline solid var(--dark-grey);
    }

    p {
        padding-top: 4px;
        padding-left: 1rem;
    }
    time {
        font-style: italic;
        padding-top: 10px;
        padding-left: 3px;
    }

    @media screen and (max-width: 500px) {
        article {
            flex-direction: column;
        }
        p {
            padding-left: unset;
        }
        time {
            padding: 6px 2px;
        }
    }

</style>
